'use client';

import { ReactNode, useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

export function ScrollRail({ children, className }: { children: ReactNode; className?: string }) {
  const railRef = useRef<HTMLDivElement>(null);

  const scrollByPage = (direction: -1 | 1) => {
    const rail = railRef.current;
    if (!rail) return;
    rail.scrollBy({ left: direction * rail.clientWidth * 0.85, behavior: 'smooth' });
  };

  return (
    <div className={cn('relative', className)}>
      <button
        type="button"
        onClick={() => scrollByPage(-1)}
        className="absolute left-1 top-1/2 z-10 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white text-slate-900 shadow-lg ring-1 ring-slate-200 transition hover:bg-rose-50 hover:text-rose-700"
        aria-label="Vorige items"
      >
        <ChevronLeft className="h-5 w-5" />
      </button>
      <div
        ref={railRef}
        // overflow-y-hidden: de rail had enkele pixels verticale overflow,
        // waardoor Chrome muiswiel-events hier liet sterven in plaats van de
        // pagina te scrollen. scroll-smooth zit al op de knop-scroll zelf.
        className="-mx-4 overflow-x-auto overflow-y-hidden px-4 pb-4 [scrollbar-width:thin]"
      >
        {children}
      </div>
      <button
        type="button"
        onClick={() => scrollByPage(1)}
        className="absolute right-1 top-1/2 z-10 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white text-slate-900 shadow-lg ring-1 ring-slate-200 transition hover:bg-rose-50 hover:text-rose-700"
        aria-label="Volgende items"
      >
        <ChevronRight className="h-5 w-5" />
      </button>
    </div>
  );
}
